/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import classNames from 'classnames';

import React, {useMemo, CSSProperties} from 'react';

interface Props {
    className?: string;
    smile?: boolean;
    size?: number | string;
}

export default function BolSmile(props: Props) {
    const {smile, className, size} = props;
    const style: CSSProperties = useMemo(() => {
        const style: CSSProperties = {};
        if (size) {
            style.width = size;
            style.height = size;
        }
        return style;
    }, [size]);

    return (
        <svg
            version='1.1'
            viewBox='0 0 120 120'
            aria-label='DATA'
            role='img'
            className={classNames('bol-smile-icon', className)}
            focusable='false'
            style={style}
        >
            <g id='Characters'>
                <circle cx='60' cy='60.35' r='36.35' fill='#2568EF'></circle>
                {smile !== false && (
                    <path
                        fill='white'
                        d='M60.46 83.19H60a18.66 18.66 0 01-19.11-18.14 1.4 1.4 0 011.36-1.44A1.44 1.44 0 0143.69 65 15.93 15.93 0 0060 80.39 15.89 15.89 0 0076.31 65a1.45 1.45 0 011.44-1.36 1.4 1.4 0 011.36 1.44 18.69 18.69 0 01-18.65 18.11z'
                    ></path>
                )}
            </g>
        </svg>
    );
}
